import { api } from "@/lib/api-client";
import { isImpersonatedSession } from "@/utils/impersonation";
import { AnnouncementModal } from "./AnnouncementModal";

export function AnnouncementHost() {
  const { data } = api.announcements.useGetActiveAnnouncement({
    enabled: !isImpersonatedSession(),
  });

  if (!data?.announcement) {
    return null;
  }

  return <AnnouncementModal announcement={data.announcement} />;
}
